;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

const publicProviderMessageable = gql`
  query publicProviderMessageable($iProviderId: Int!) {
    publicProviderMessageable(iProviderId: $iProviderId) {
      nodes {
        canMessage
      }
    }
  }
`

export default publicProviderMessageable
